export default class CustomGroupShowCtrl {
    constructor($scope, $state, $stateParams, $filter, Customization, SideMenu, SweetAlert, Events) {
        SideMenu.setActive('subscriber');

        this._stateParams = $stateParams;
        this._state = $state;
        this._scope = $scope;
        this._filter = $filter;

        this.customizeRepo = Customization;
        this.sweetAlert = SweetAlert;
        this.eventHandler = Events;

        this.settings = {
            showCreateField: false,
            newField: '',
            disableBtnCreate: true
        };

        this.loading = true;

        this.customizeRepo.findGroup(this._stateParams.id).then((group) => {
            this.group = group.data;
            this.loading = false;
            this.originalName = this.group.name;
            this.settings.disableBtnCreate = false;
        });

        this._scope.$on('account:changed', () => {
            this._state.go('subscriber.groups');
        });
    }

    close() {
        this._state.go('subscriber.groups');
    };

    updateGroupName(data) {
        if (data != this.group.name) {
            this.group.name = data;
            this.updateGroup();
        }
    };

    createField() {
        if (! this.settings.newField || this.settings.disableBtnCreate) {
            return;
        }

        this.settings.disableBtnCreate = true;

        let newFieldName = this.settings['newField'];

        this.customizeRepo.storeField(this._stateParams.id, this.settings.newField).then((field) => {
            this.group.fields.push(field.data);
            this.settings['newField'] = '';
            this.settings.disableBtnCreate = false;
        }, (error) => {
            this.settings['newField'] = '';
            this.settings.disableBtnCreate = false;
            if (error.data.code == 9) {
                this.sweetAlert.swal({
                    title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                    text: this._filter('translate')('CUSTOMIZE:FLASH:DUPLICATE_FIELD_UPDATE').replace(/:name/, newFieldName),
                    type: 'error'
                });
            } else if (error.data.code == 8) {
                this.sweetAlert.swal({
                    title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                    text: this._filter('translate')('CUSTOMIZE:FLASH:RESERVED_KEYWORD').replace(/:name/, newFieldName),
                    type: 'error'
                });
            } else if (error.data.code == 10) {
                SweetAlert.swal({
                    title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                    text: this._filter('translate')('CUSTOMIZE:FLASH:FIELD_NAME_INVALID_OR_EMPTY'),
                    type: 'error'
                });
            } else {
                this.sweetAlert.swal({
                    title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                    text: this._filter('translate')('CUSTOMIZE:FLASH:CREATE_FIELD_ERROR'),
                    type: 'error'
                });
            }
        });
    };

    updateGroup() {
        this.customizeRepo.updateGroup(this.group).then(() => {
            this.originalName = this.group.name;
            this.originalHistoricalFlag = this.group.historical
            this.eventHandler.flashEvent('notification', this._filter('translate')('CUSTOMIZE:FLASH:GROUP_UPDATED'));
        }, (error) => {
            var msg;

            if (error.data.code == 9) {
                msg = this._filter('translate')('CUSTOMIZE:FLASH:DUPLICATE_GROUP_UPDATE').replace(/:name/, this.group.name);
            } else if (error.data.name) {
                msg = this._filter('translate')('CUSTOMIZE:FLASH:ERROR:INVALID_GROUP_NAME');
            } else if (error.data.code == 10) {
                msg = this._filter('translate')('CUSTOMIZE:FLASH:GROUP_NAME_INVALID_OR_EMPTY');
            } else if (error.data.code === 11) {
                msg = this._filter('translate')('CUSTOMIZE:FLASH:GROUP_DATA_IS_DELETING');
            } else {
                msg = this._filter('translate')('CUSTOMIZE:FLASH:UPDATE_GROUP_ERROR');
            }

            this.sweetAlert.swal({
                title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                text: msg,
                type: 'error'
            });

            this.group.name = this.originalName;
            this.group.historical = this.originalHistoricalFlag;
        });
    };

    showCreateFieldBtn() {
        this.settings.showCreateField = false;
    };

    getNewFieldName() {
        let fieldsNames = this.group.fields.map(field => field.name);
        this.settings.newField = this._filter('getNumberedName')(fieldsNames, 'New');
    }

    toggleHistorical() {
        var text = this.group.historical ? 'CUSTOMIZE:GROUP:MAKE_HISTORICAL' : 'CUSTOMIZE:GROUP:MAKE_NON_HISTORICAL';
        var title = this.group.historical ? 'CUSTOMIZE:GROUP:TOGGLE_NON_HISTORICAL:HEADER' : 'CUSTOMIZE:GROUP:TOGGLE_HISTORICAL:HEADER';

        this.sweetAlert.swal({
            title: this._filter('translate')(title),
            text: this._filter('translate')(text),
            type: 'warning',
            customClass: this.group.historical ? '' : 'sweet-alert--delete',
            showCancelButton: true,
            cancelButtonText: this._filter('translate')('GLOBAL:NO'),
            confirmButtonText: this._filter('translate')('GLOBAL:YES')
        }, (isConfirm) => {
            if (isConfirm) {
                this.updateGroup()
            } else {
                this.group.historical = ! this.group.historical;
            }
        });
    }
};
